export default ['VANP'];
